"use client";

import { createContext, useContext, type ReactNode } from "react";

/**
 * Whether the current request came from the phone app, decided on the server and handed
 * down so client components can branch without a hydration flash.
 *
 * The legal pages are the reason this exists. They are opened from inside the app (settings,
 * signup) AND linked from the website footer, and they need to look like two different things:
 * a plain app screen with a back button, or a page of the website with its navigation. Deciding
 * that on the client with isCapacitorApp() would paint the wrong one first.
 */
const NativeShellContext = createContext(false);

export function NativeShellProvider({ value, children }: { value: boolean; children: ReactNode }) {
  return <NativeShellContext.Provider value={value}>{children}</NativeShellContext.Provider>;
}

/** True when this page is being rendered inside the iOS or Android shell. */
export function useIsNativeShell() {
  return useContext(NativeShellContext);
}
